module.exports = __webpack_public_path__ + "img/Ruins.b7a08566.png";